export enum AppointmentsEnum {
  Installation = "installation",
  Removal = "removal",
}
